import { FC, CSSProperties } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface RawResponseViewProps {
  content: string;
}

const CONTAINER_STYLE: CSSProperties = {
  background: '#ffffff',
  border: '1px solid #e9ebed',
  borderRadius: 8,
  padding: 16,
  maxHeight: 500,
  overflow: 'auto',
  fontSize: 14,
  lineHeight: '1.7',
  color: '#16191f',
};

const CODE_BLOCK_STYLE: CSSProperties = {
  background: '#e9ebed',
  padding: '8px 12px',
  borderRadius: 6,
  overflowX: 'auto',
  fontSize: 13,
  lineHeight: 1.5,
};

const INLINE_CODE_STYLE: CSSProperties = {
  background: '#e9ebed',
  padding: '1px 4px',
  borderRadius: 3,
  fontSize: 13,
};

const STREAM_METADATA_REGEX = /^\s*\{/;

const sanitizeStreamContent = (raw: string): string => {
  const lines = raw.split('\n');
  const filtered: string[] = [];
  for (const line of lines) {
    if (STREAM_METADATA_REGEX.test(line)) {
      console.log('[RawResponseView] filtered:', line);
    } else {
      filtered.push(line);
    }
  }
  return filtered.join('\n').trim();
};

const RawResponseView: FC<RawResponseViewProps> = ({ content }) => (
  <div style={CONTAINER_STYLE}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        code({ inline, children, ...props }) {
          return inline ? (
            <code style={INLINE_CODE_STYLE} {...props}>{children}</code>
          ) : (
            <pre style={CODE_BLOCK_STYLE}><code {...props}>{children}</code></pre>
          );
        },
        table({ children }) {
          return (
            <table style={{ borderCollapse: 'collapse', width: '100%', margin: '8px 0' }}>
              {children}
            </table>
          );
        },
        th({ children }) {
          return (
            <th style={{ border: '1px solid #d5dbdb', padding: '8px 12px', background: '#f2f3f3', fontWeight: 700, textAlign: 'left' }}>
              {children}
            </th>
          );
        },
        td({ children }) {
          return (
            <td style={{ border: '1px solid #d5dbdb', padding: '8px 12px' }}>
              {children}
            </td>
          );
        },
      }}
    >
      {sanitizeStreamContent(content)}
    </ReactMarkdown>
  </div>
);

export default RawResponseView;
